import { Component, inject } from '@angular/core';
import { LayoutService } from '../../services/layout.service';

@Component({
    selector: 'app-footer',
    imports: [],
    template: `
        <footer class="layout-footer" [class.no-left-bar]="layoutService.layoutState().staticMenuDesktopInactive">
            <span>© 2026 CITY | Università di Roma "La Sapienza" | Powered by <a href="https://philmarkinformatica.it/" target="_blank" rel="noopener noreferrer">Philmark</a></span>
        </footer>
    `
})
export class FooterComponent {
    protected readonly layoutService = inject(LayoutService);
}
